import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalNewTicket from './PortalNewTicket';
import PortalTrackTicket from './PortalTrackTicket';
import PortalRate from './PortalRate';
import PortalHelp from './PortalHelp';
import PortalLogin from './PortalLogin';
import PortalRegister from './PortalRegister';
import PortalDashboard from './PortalDashboard';
import PortalTicketDetail from './PortalTicketDetail';

/**
 * Albero di route del portale clienti, con un proprio stato di
 * autenticazione (customer_token/customer_user in localStorage, non
 * token/user usati dallo staff) — indipendente da AppContent, così un
 * agente e un cliente possono avere entrambe le sessioni aperte nello
 * stesso browser senza clobber reciproco.
 */
function PortalApp() {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('customer_user');
    if (saved) {
      try {
        setCustomer(JSON.parse(saved));
      } catch {
        localStorage.removeItem('customer_token');
        localStorage.removeItem('customer_user');
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, customerData) => {
    localStorage.setItem('customer_token', token);
    localStorage.setItem('customer_user', JSON.stringify(customerData));
    setCustomer(customerData);
  };

  const handleLogout = () => {
    localStorage.removeItem('customer_token');
    localStorage.removeItem('customer_user');
    setCustomer(null);
  };

  if (loading) {
    return <div className="loading">...</div>;
  }

  const isAuthenticated = !!customer;

  return (
    <Routes>
      <Route path="/dashboard" element={isAuthenticated ? <PortalDashboard customer={customer} onLogout={handleLogout} /> : <Navigate to="/portal" replace />} />
      <Route path="/tickets/:id" element={isAuthenticated ? <PortalTicketDetail customer={customer} onLogout={handleLogout} /> : <Navigate to="/portal" replace />} />
      <Route path="/ticket/:token" element={<PortalTrackTicket />} />
      <Route path="/rate/:token" element={<PortalRate />} />
      <Route path="/:projectSlug/help/:id" element={<PortalHelp />} />
      <Route path="/:projectSlug/login" element={<PortalLogin onLogin={handleLogin} />} />
      <Route path="/:projectSlug/register" element={<PortalRegister />} />
      <Route path="/:projectSlug" element={<PortalNewTicket />} />
      <Route
        path="*"
        element={
          isAuthenticated ? (
            <Navigate to="/portal/dashboard" replace />
          ) : (
            <div className="loading">Link non valido: manca il riferimento al progetto.</div>
          )
        }
      />
    </Routes>
  );
}

export default PortalApp;
